import { PollGetRes, UserPollGetReq } from "shared/src/network/requests/poll/poll-req-models";
import { apiRequest } from "../../../framework/network/api-client";
import { Id } from "../../../models/framework/db";
import { UserInfo } from "../../../models/user/user-info";
import { ApiUrlPath as AUP } from "../../url-paths";
import {
    RemovePlayerIdsReq,
    UserAddReq,
    UserAddRes,
    UserFollowReq,
    UserGetRes,
    UserInfoPlayerIdsReq,
    UserPollAddReq,
} from "./user-req-models";

export const userAdd = async (body: UserAddReq, host?: string) =>
    await apiRequest<UserAddRes>(AUP.userAdd, body, host);

export const userFollow = async (body: UserFollowReq, host?: string) =>
    await apiRequest<UserAddRes>(AUP.userFollow, body, host);

export const userUnfollow = async (body: UserFollowReq, host?: string) =>
    await apiRequest<UserAddRes>(AUP.userUnfollow, body, host);

export const userUpdate = async (body: UserInfo, host?: string) =>
    await apiRequest<UserAddRes>(AUP.userUpdate, body, host);

export const userGet = async (body: {}, host?: string) =>
    await apiRequest<UserGetRes>(AUP.userGet, body, host);

export const getAllUser = async (body: {}, host?: string) =>
    await apiRequest<Array<Id<UserInfo>>>(AUP.userGetAll, body, host);

export const createBootUser = async (body: { id: string }, host?: string) =>
    await apiRequest<{}>(AUP.bootUserAdd, body, host);

export const userCreatePoll = async (body: UserPollAddReq, host?: string) =>
    await apiRequest<{ status: boolean; pollId: string }>(AUP.userAddPoll, body, host);

export const userSetPlayerId = async (body: UserInfoPlayerIdsReq, host?: string) =>
    await apiRequest<{ status: boolean }>(AUP.userSetPlayerId, body, host);

export const removePlayerId = async (body: RemovePlayerIdsReq, host?: string) =>
    await apiRequest<{ status: boolean }>(AUP.removePlayerId, body, host);

export const fetchUserCreatedPolls = async (body: UserPollGetReq, host?: string) =>
    await apiRequest<PollGetRes>(AUP.userGetPolls, body, host);
